import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { components } from 'react-select'

import ConditionalWrapper from 'components/ConditionalWrapper'

import styles from '../styles.module.css'

function Option({ children, ...props }) {
  const elementRef = useRef(null)
  const containerRef = useRef(null)
  const [isOverflown, setIsOverflown] = useState(false)

  useEffect(() => {
    if (elementRef.current && containerRef.current) {
      setIsOverflown(
        elementRef.current.offsetWidth >= containerRef.current.offsetWidth
      )
    }
  }, [elementRef, containerRef])

  return (
    <ConditionalWrapper
      condition={isOverflown}
      wrapper={(children) => (
        <OverlayTrigger
          delayShow={400}
          delayHide={150}
          placement="bottom"
          overlay={
            <Popover
              className={classNames(styles.popover, {
                [styles.hide]: !isOverflown,
              })}
              id={props.data.value}
            >
              {props.data.path[props.data.path.length - 1]}
            </Popover>
          }
          trigger={['hover', 'focus']}
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <div className={styles.valueLabelContainer} ref={containerRef}>
        <components.Option {...props}>
          <span
            ref={elementRef}
            className={`${isOverflown ? styles.overflow : ''}`}
          >
            {children}
          </span>
        </components.Option>
      </div>
    </ConditionalWrapper>
  )
}

export default Option
